import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <div className="sidebar">
        <div className="sidebar-header">
          <h2>InfoChatbot</h2>
          <p>Analytics Dashboard</p>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            📊 Dashboard
          </NavLink>
          <NavLink to="/chats" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            💬 Conversazioni
          </NavLink>
          <NavLink to="/costs" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            💰 Analisi Costi
          </NavLink>
          <NavLink to="/errors" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            ⚠️ Errori
          </NavLink>
          <NavLink to="/performance" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            ⏱️ Performance
          </NavLink>
          {isAdmin() && (
            <NavLink to="/users" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              👥 Utenti
            </NavLink>
          )}
        </nav>

        <div style={{ position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
          <div style={{ padding: '15px', background: '#34495e', borderRadius: '5px', marginBottom: '10px' }}>
            <div style={{ fontSize: '14px', marginBottom: '5px' }}>
              <strong>{user?.full_name}</strong>
            </div>
            <div style={{ fontSize: '12px', color: '#95a5a6' }}>
              {user?.email}
            </div>
            <div style={{ fontSize: '11px', marginTop: '5px' }}>
              <span style={{
                background: user?.role === 'admin' ? '#ffeaa7' : '#dfe6e9',
                color: user?.role === 'admin' ? '#d63031' : '#2d3436',
                padding: '2px 6px',
                borderRadius: '3px',
                fontWeight: 'bold'
              }}>
                {user?.role?.toUpperCase()}
              </span>
            </div>
          </div>
          <button
            className="btn btn-danger"
            style={{ width: '100%' }}
            onClick={handleLogout}
          >
            🚪 Logout
          </button>
        </div>
      </div>

      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default Layout;

